(() => {
  // Cookie management functions
  const setCookie = (name, value, days = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  };

  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  // Generate random alphanumeric string
  const generateRandomString = (length = 16) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  // Initialize anonymous user token (PP-753: fixed race condition)
  const initializeAnonymousUser = () => {
    const cookieName = 'algolia_anonymous_user_token';
    let userToken = getCookie(cookieName);

    if (!userToken) {
      userToken = `anonymous-user-${generateRandomString()}`;
      setCookie(cookieName, userToken);
    }

    // aa() is guaranteed to exist as a queue function after algolia-insights-init.js
    // Queued calls are processed in order once the library loads,
    // so this setUserToken will execute after the init() call.
    if (window.aa) {
      window.aa('setUserToken', userToken);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAnonymousUser);
  } else {
    initializeAnonymousUser();
  }
})(); 